import { Grid3x3 } from '@mui/icons-material';
import TicTacToe from './TicTacToe';

const tictactoe = {
    id: 'tictactoe',
    title: 'Tic Tac Toe',
    icon: Grid3x3,
    summary: 'A 3x3 board for two people on one screen, or one person against an LLM. The rules are one pure state machine, so the opponent plugs in without touching them.',
    blurb: 'Hot-seat or vs AI. The rules live in one play(game, cell) transition with no UI or network in it, and who supplies each move is a mark-to-player table — a human clicking, or a call to a backend that asks Gemini for a cell and a reason.',
    steps: [
        'Pick two players or vs AI',
        'X and O alternate on one board',
        'Against the AI, watch its move arrive with a one-line reason',
        'Three in a row lights up and freezes play',
        'Play again resets without leaving the page',
    ],
    tech: ['React', 'Pure rules engine', 'Backend calling Gemini via the Vercel AI SDK'],
    href: '/tictactoe',
    cta: 'Play Tic Tac Toe',
    Page: TicTacToe,
};

export default tictactoe;
